<template>
  <div>
    <ul>
      <li>{{'DOWNLOAD_PDF_1' | translate}}</li>
      <li>{{'DOWNLOAD_PDF_2' | translate}}</li>
      <li>{{'DOWNLOAD_PDF_3' | translate}}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'MockTabDocuments.vue',
  data: () => ({
    currentItem: 'tab-Web',
    items: [
      'Nichtmonetäre Daten', 'Aktiva', 'Passiva', 'GuV'
    ],
    more: [],
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
  }),

  methods: {
    addItem (item) {
      const removed = this.items.splice(0, 1)
      this.items.push(
        ...this.more.splice(this.more.indexOf(item), 1)
      )
      this.more.push(...removed)
      this.$nextTick(() => { this.currentItem = 'tab-' + item })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/module/mockups/MockTabDocuments.vue